import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  ListItem,
  ListItemText,
  Switch,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { SlHome } from "react-icons/sl";
import { FiUser } from "react-icons/fi";
import { VscServerProcess } from "react-icons/vsc";
import { IoBriefcaseOutline } from "react-icons/io5";
import { MdOutlineContactPhone } from "react-icons/md";
import { motion } from "framer-motion";
const useStyles = makeStyles((theme) => ({
  customStyle: {
    transform: "translateY(200px)",
  },
  customSidebar: {
    position: "fixed",
    height: "100vh",
    width: "170px",
    backgroundColor: "#121212",
  },
  MobileMenu: {
    position: "fixed",
    left: "0",
    bottom: "0",
    width: "100%",
  },
  ListItemChanged: {
    color: "#fff !important",
    textDecoration: "none",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 0 10px 15px",
    "&:hover": {
      color: theme.palette.dark.main,
      backgroundColor: "#222",
    },
    "&.active": {
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
    },
  },
  selected: {
    backgroundColor: "#0066ff !important",
    color: "#fff !important",
  },
}));
function Sidebar({ mode, setMode }) {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  const [checked, setChecked] = useState(false);

  const [value, setValue] = React.useState(0);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const classes = useStyles();
  return (
    <>
      <motion.div
        initial={{ y: "200px" }}
        animate={{ y: 0, transition: { duration: 1.5 } }}
      >
        <Box
          className={classes.MobileMenu}
          sx={{ display: { xs: "block", sm: "none" }, zIndex: "999" }}
        >
          <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            sx={{ width: "100%", backgroundColor: "#121212" }}
          >
            <BottomNavigationAction
              className={value === 0 ? classes.selected : ""}
              component={NavLink}
              to="/"
              label="Home"
              value={0}
              icon={<SlHome style={{ fontSize: "20px", color: "#fff" }} />}
              onClick={handleClick}
            />
            <BottomNavigationAction
              className={value === 1 ? classes.selected : ""}
              component={NavLink}
              to="about"
              label="About"
              value={1}
              icon={<FiUser style={{ fontSize: "22px", color: "#fff" }} />}
              onClick={handleClick}
            />
            <BottomNavigationAction
              className={value === 2 ? classes.selected : ""}
              component={NavLink}
              to="services"
              label="Services"
              value={2}
              icon={
                <VscServerProcess style={{ fontSize: "22px", color: "#fff" }} />
              }
              onClick={handleClick}
            />
            <BottomNavigationAction
              className={value === 3 ? classes.selected : ""}
              component={NavLink}
              to="portfolio"
              label="Portfolio"
              value={3}
              icon={
                <IoBriefcaseOutline
                  style={{ fontSize: "20px", color: "#fff" }}
                />
              }
              onClick={handleClick}
            />
            <BottomNavigationAction
              className={value === 4 ? classes.selected : ""}
              component={NavLink}
              to="contact"
              label="Contact"
              value={4}
              icon={
                <MdOutlineContactPhone
                  style={{ fontSize: "20px", color: "#fff" }}
                />
              }
              onClick={handleClick}
            />
          </BottomNavigation>
        </Box>
      </motion.div>

      <motion.div
        initial={{ x: "-300px" }}
        animate={{ x: 0, transition: { duration: 1.5 } }}
      >
        <Box
          sx={{ display: { xs: "none", sm: "block" } }}
          className={classes.customSidebar}
        >
          <Box className={classes.customStyle}>
            <ListItem
              className={classes.ListItemChanged}
              component={NavLink}
              to="/"
            >
              <SlHome style={{ marginRight: "15px", fontSize: "20px" }} />
              <ListItemText primary="Home" />
            </ListItem>

            <ListItem
              className={classes.ListItemChanged}
              component={NavLink}
              to="about"
            >
              <FiUser style={{ marginRight: "15px", fontSize: "22px" }} />
              <ListItemText primary="About" />
            </ListItem>

            <ListItem
              className={classes.ListItemChanged}
              component={NavLink}
              to="services"
            >
              <VscServerProcess
                style={{ marginRight: "15px", fontSize: "22px" }}
              />
              <ListItemText primary="Services" />
            </ListItem>

            <ListItem
              className={classes.ListItemChanged}
              component={NavLink}
              to="portfolio"
            >
              <IoBriefcaseOutline
                style={{ marginRight: "15px", fontSize: "22px" }}
              />
              <ListItemText primary="Portfolio" />
            </ListItem>

            <ListItem
              className={classes.ListItemChanged}
              component={NavLink}
              to="contact"
            >
              <MdOutlineContactPhone
                style={{ marginRight: "15px", fontSize: "22px" }}
              />
              <ListItemText primary="Contact" />
            </ListItem>

            <Button
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                color: "#fff",
                width: "100%",
                padding: "10px 5px",
              }}
              onClick={() => {
                setMode(!mode);
                setChecked(!checked);
              }}
            >
              <Switch
                checked={checked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
              {mode ? <Box>Light</Box> : <Box>Dark</Box>}
            </Button>
          </Box>
        </Box>
      </motion.div>
    </>
  );
}

export default Sidebar;
